// extracted by mini-css-extract-plugin
export var borderRadius = "_f7-4";
export var large = "_f7-3";
export var logoContainer = "_f7-0";
export var nameLogo = "_f7-2";
export var small = "_f7-1";